define([
    "jquery",
    "underscore",
    "marionette"
], function($, _, Marionette){
    /**
     HOW TO USE,
     1. Load behavior to your View
     - define([ ... "behaviors/recaptcha_v3_behavior" ... ])
     - function( ... ReCaptchaV3Behavior ... )

     2. Init this behavior with an option followings
     - 1) action : the action you would like to declare uniquely
     behaviors: {
        ...
        recaptcha : {
            behaviorClass: ReCaptchaV3Behavior,
            action: '__your_action__'
        }
        ...
     },

     3. Load recaptcha library by calling, this.triggerMethod('init:recaptcha')
     - Mostly declare within initilize function

     4. Differently with RecaptchaV2, the token only last 2 minutes.
     Thus, you should get tokens right before users' submitting action.
     // get token
     this.triggerMethod('validate:recaptcha', function(err, token){
        if(err) // Do something
        // set token received from parent' request.
        that.triggerMethod('set:token', token, that.ui.inquirySubmitForm);
        // token : received from previous callback function.
        // that.ui.inquirySubmitForm : your form ui that later need to be submitted after validation

        // after setting up the token,
        // do your stuff bottom below
     }
     */
    return Marionette.Behavior.extend({
        options: {
            action : '',
        },
        ui: {

        },
        events: {

        },

        onInitRecaptcha: function(){
            this.sitekey = window.recaptcha_sitekey;
            this.grecaptchaObject = {
                isCalled : false,
                obj: function(){}
            };
            var that = this;
            $.getScript("https://www.google.com/recaptcha/api.js?render=" + this.sitekey,function(data, textStatus, jqxhr){
                grecaptcha.ready(function(){
                    that.grecaptchaObject.isCalled = true;
                    that.grecaptchaObject.obj = grecaptcha;
                    console.log("ReCaptchaV3 Ready");
                });
            });
        },

        onValidateRecaptcha: function(callback){
            console.log("trigggered onValidateRecaptcha");
            if(!this.grecaptchaObject.isCalled){
                console.log("Initialize site key first on behavior declaration");
                return callback("RECAPTCHA FAILED");
            }
            this.grecaptchaObject.obj.execute(this.sitekey, {action : this.getOption('action')}).then(function(token){
                callback(null, token);
            })
        },

        onGetToken: function(callback){
            this.grecaptchaObject.obj.execute(this.sitekey, {action : this.getOption('action')}).then(function(token){
                callback(null, token);
            })
        },

        onSetToken: function(token, uiForm){
            uiForm.append("<input type='hidden' name='g-recaptcha-response' id='g-recaptcha-response' value='" + token + "'>");
        },

        _isActionDeclared: function(){
            this.getOption('action')
        }

    });
});
